import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import CommitmentLayout from './CommitmentLayout'

class ProviderCommitmentLayout extends Component {
    static propTypes = {
    }

    render() {
        const {dispatch, provider, reference} = this.props

        return (
            <CommitmentLayout
                committed={provider}
                commitments={provider.activities}
                activityReference={reference} />
        )
    }
}

ProviderCommitmentLayout = connect((state) => ({
    provider: state.provider.provider,
    reference: state.reference.activityRef
}))(ProviderCommitmentLayout)

export default ProviderCommitmentLayout


// WEBPACK FOOTER //
// ./lib/provider/components/ProviderCommitmentLayout.js